import React from 'react';
import {
  TextTitle,
} from './SetNewPassword.style';
import PrimaryButton from '../../../../components/PrimaryButton/PrimaryButton.component';
import { t } from '../../../../i18n';
import API from 'src/api/api';
import { useLocation } from 'react-router-dom';
import ErrorPopup from 'src/components/ErrorPopup/ErrorPopup';
import LoadingContainer from 'src/components/LoadingContainer/LoadingContainer';
import { pathOr } from 'ramda';

import { PasswordsWithValidation } from '@legwork/react-ui-components';

interface IProps {
  setStepVerify(step: number): void;
  setSetPasswordSuccessful(a: boolean): void;
  whenSetPasswordSuccessful(token: string, contactId: string): void;
}

const SetNewPasswordForm: React.FC<IProps> = ({
  setStepVerify,
  setSetPasswordSuccessful,
  whenSetPasswordSuccessful
}) => {
  const query = new URLSearchParams(useLocation().search);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const [showErrorPopup, setShowErrorPopup] = React.useState<boolean>(false);

  const email = decodeURIComponent(query.get('email') || '');

  const handleSubmit = ({
    password, 
  }) => {
    setIsLoading(true);

    const keyToSetNewPassword = decodeURIComponent(query.get('key') || '');

    API()
      .post('/auth/v1/public/reset-password', {
        key: keyToSetNewPassword,
        password
      })
      .then((response) => {
        if (response.status === 200) {
          whenSetPasswordSuccessful(response.data.token, response.data.contactId);
          setSetPasswordSuccessful(true);
        }

        setIsLoading(false);
      })
      .catch((error) => {
        if (error.response.status) {
          const errorMessageFromAPI = pathOr(error.message, [
            'response',
            'data',
            'message'
          ])(error);

          setIsLoading(false);

          setErrorMessage(errorMessageFromAPI);
          setShowErrorPopup(true);

          return;
        }

        setIsLoading(false);

        setErrorMessage(error);
        setShowErrorPopup(true);
      });
  }

  React.useEffect(() => {
    setIsLoading(true);
    
    const keyToVerify = decodeURIComponent(query.get('key') || '');

    API()
      .post('/auth/v1/public/verify-reset-key', {
        key: keyToVerify
      })
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (!err.response.status) {
          setIsLoading(false);

          return;
        }

        setStepVerify(1);
        setIsLoading(false);
      });
  }, []);

  return (
    <LoadingContainer isLoading={isLoading} isOverlay={true}>
      <>
        <TextTitle>{t('signIn.setYourPassword')}</TextTitle>
      
        <PasswordsWithValidation 
          onSubmit={handleSubmit}
          usernameOrEmail={email}
        />

        <ErrorPopup
          showErrorPopup={showErrorPopup}
          setShowErrorPopup={setShowErrorPopup}
          errorMessage={errorMessage}
        />
      </>
    </LoadingContainer>
  );
};

export default SetNewPasswordForm;